"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var utils_1 = require("../../utils");
exports.default = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_SECTIONS, actions_1.ADD_SECTION, actions_1.UPDATE_SECTION, actions_1.DELETE_SECTION);
